import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints';

export interface Template {
  id: string;
  name: string;
  isVisible: boolean;
  description: string;
}

export const physicianInterpretationApiSlice = createApi({
  reducerPath: 'physicianInterpretationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: Object.values(API_SLICE.PhysicianInterpretation),
  endpoints: (builder) => ({
    getAllPhysicianInterpretation: builder.query<Template[], number>({
      query: (reportId: number) => ({
        url: API_ENDPOINTS.V2_PHYSICIAN_INTERPRETATION.LIST(reportId),
        method: 'GET'
      }),
      transformResponse: (response: { templates: Template[] }) => response.templates
    })
  })
});

export const { useGetAllPhysicianInterpretationQuery } = physicianInterpretationApiSlice;
